export { DigPdfViewerComponent } from "./dig-pdf-viewer.component";
